import styled from 'styled-components';

export const TwoColumnsGrid = styled.div`
   display: grid;
   grid-template-columns: 151px 1fr;
   gap: 20px;
   width: 100%;
`;

TwoColumnsGrid.displayName = 'TwoColumnsGrid';

export const ThreeColumnsGrid = styled.div`
   display: grid;
   grid-template-columns: 120px 158px 93px;
   gap: 20px;
   width: 100%;
`;

ThreeColumnsGrid.displayName = 'ThreeColumnsGrid';

export const OneColumnSpan = styled.div`
   grid-column: span 2;
   display: flex;
   flex-direction: column;
   gap: 20px;
`;

OneColumnSpan.displayName = 'OneColumnSpan';
